import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { fromJS, Record } from 'immutable';

export const XERO_AUTH_URL_SCHEMA = Object.freeze({
  AUTHORIZATION_URL: '',
});

const RECORD = generateSchema(XERO_AUTH_URL_SCHEMA);
const KEYS: any = generateKeys(XERO_AUTH_URL_SCHEMA);

export class XeroAuthUrl extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get authorizationUrl(): string {
    return this.get(KEYS.AUTHORIZATION_URL);
  }
}
